export enum WellKnownAttribute {
  Price = 'Price',
  Name = 'Name',
  Description = 'Description',
  Article = 'Article',
}
